import type { ProductConfig } from '../../default/product/product.types';
import type { DeepPartial } from '../../default/types';

export const productConfig: DeepPartial<ProductConfig> = {
  recommendations: {
    dv: {
      slots: {
        1: 'seriesProducts',
        2: 'searchProductToProducts',
        4: 'searchReplace',
      },
    },
    atb: {
      slots: {
        1: 'searchBasketToProducts',
        2: null,
      },
    },
    isUsingPrudsys: false,
  },
  cliplister: {
    customerId: '81856',
  },
  ecoFriendlyDelivery: {
    enabled: true,
  },
  hasKIM: false,
};
